module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/5n7cjV/tc-custom/9781633410008.jpg?1704298090763",
      "alt": "This image is the cover for the book H.P. Lovecraft & the Black Magickal Tradition"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("H.P. Lovecraft & the Black Magickal Tradition\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Explore Lovecraft's Deep Connections to the Dark Arts Modern practicing occultists have argued that renowned horror writer H. P. Lovecraft was in possession of in-depth knowledge of black magick. Literary scholars claim that he was a master of his genre and craft, and his findings are purely psychological, nothing more. Was Lovecraft a practitioner of the dark arts himself? Was he privileged to knowledge that cannot be otherwise explained? Weaving the life story of Lovecraft in and out of an analysis of various modern magickal systems, scholar John L. Steadman has found direct and concrete examples that demonstrate that Lovecraft's works and specifically his Cthulhu Mythos and his creation of the Necronomicon are a legitimate basis for a working magickal system. Whether you believe Lovecraft had supernatural powers or not, no one can argue against Lovecraft's profound influence on many modern black arts and the darker currents of western occultism.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      John L. Steadman\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("John L. Steadman is a scholar of H. P. Lovecraft and western occultism and has been a magickal practitioner for more than thirty years. He is currently a college English professor at Olivet College in Michigan. Visit him at www.johnlsteadman.com.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Weiser Books\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0